// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"966eabc9","389":"9c595619","453":"d257f51a","455":"64e1c378","977":"5ec0c4a2"}[chunkId] + ".chunk.js";
};